import React from 'react';
import PropTypes from 'prop-types';

const Heading = (props) => {
  const { children } = props;

  return <div className="blueprint-heading">{children}</div>;
};

Heading.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Heading;
